










































































































































































































import Component from "vue-class-component";
import MedicalSpecificationBase from "@/components/medicalEdit/specification/MedicalSpecificationBase";
import DiseaseSettingDialog from "@/components/medicalEdit/DiseaseSettingDialog.vue";
import BasicInfo1 from "@/components/medicalEdit/specification/part/basicInfo/BasicInfo1.vue";
import BasicInfo2 from "@/components/medicalEdit/specification/part/basicInfo/BasicInfo2.vue";
import BasicInfo3 from "@/components/medicalEdit/specification/part/basicInfo/rev3/BasicInfo3.vue";
import BasicInfo4 from "@/components/medicalEdit/specification/part/basicInfo/BasicInfo4.vue";
import BasicInfo5 from "@/components/medicalEdit/specification/part/basicInfo/BasicInfo5.vue";
import BasicInfo6 from "@/components/medicalEdit/specification/part/basicInfo/BasicInfo6.vue";
import BasicInfo7 from "@/components/medicalEdit/specification/part/basicInfo/rev3/BasicInfo7.vue";
import BasicInfo8 from "@/components/medicalEdit/specification/part/basicInfo/BasicInfo8.vue";
import BasicInfo9 from "@/components/medicalEdit/specification/part/basicInfo/rev3/BasicInfo9.vue";
import BasicInfo10 from "@/components/medicalEdit/specification/part/basicInfo/rev3/BasicInfo10.vue";
import BasicMedical1 from "@/components/medicalEdit/specification/part/basicMedical/BasicMedical1.vue";
import BasicMedical2 from "@/components/medicalEdit/specification/part/basicMedical/BasicMedical2.vue";
import BasicMedical3 from "@/components/medicalEdit/specification/part/basicMedical/rev3/BasicMedical3.vue";
import BasicMedical4 from "@/components/medicalEdit/specification/part/basicMedical/rev3/BasicMedical4.vue";
import MindMedical1 from "@/components/medicalEdit/specification/part/mindMedical/MindMedical1.vue";
import MindMedical2 from "@/components/medicalEdit/specification/part/mindMedical/MindMedical2.vue";
import MindMedical3 from "@/components/medicalEdit/specification/part/mindMedical/rev3/MindMedical3.vue";
import MindMedical4 from "@/components/medicalEdit/specification/part/mindMedical/rev3/MindMedical4.vue";
import ManagementMedical1 from "@/components/medicalEdit/specification/part/managementMedical/rev3/ManagementMedical1.vue";
import ManagementMedical2 from "@/components/medicalEdit/specification/part/managementMedical/rev3/ManagementMedical2.vue";
import ManagementMedical3 from "@/components/medicalEdit/specification/part/managementMedical/rev3/ManagementMedical3.vue";
import OtherMedical1 from "@/components/medicalEdit/specification/part/otherMedical/rev3/OtherMedical1.vue";
import OtherMedical2 from "@/components/medicalEdit/specification/part/otherMedical/OtherMedical2.vue";
import OtherMedical3 from "@/components/medicalEdit/specification/part/otherMedical/OtherMedical3.vue";
import OtherMedical4 from "@/components/medicalEdit/specification/part/otherMedical/OtherMedical4.vue";
import FixTotal from "@/components/medicalEdit/specification/part/fixTotal/FixTotal.vue";

@Component({
  components: {
    DiseaseSettingDialog,
    BasicInfo1,
    BasicInfo2,
    BasicInfo3,
    BasicInfo4,
    BasicInfo5,
    BasicInfo6,
    BasicInfo7,
    BasicInfo8,
    BasicInfo9,
    BasicInfo10,
    BasicMedical1,
    BasicMedical2,
    BasicMedical3,
    BasicMedical4,
    MindMedical1,
    MindMedical2,
    MindMedical3,
    MindMedical4,
    ManagementMedical1,
    ManagementMedical2,
    ManagementMedical3,
    OtherMedical1,
    OtherMedical2,
    OtherMedical3,
    OtherMedical4,
    FixTotal
  }
})
export default class MedicalSpecificationRev3 extends MedicalSpecificationBase {}
